import { Header, Layout, PageContent } from '@loadsmart/miranda-react'

import { ShipperList } from './ShipperList'

export function ShippersPage() {
  return (
    <PageContent>
      <Header>
        <Header.Content>
          <Header.Title>Shippers</Header.Title>
        </Header.Content>
      </Header>
      <PageContent.Body>
        <Layout.Stack gap="spacing-6">
          <ShipperList />
        </Layout.Stack>
      </PageContent.Body>
    </PageContent>
  )
}
